const statusMap = new Map([
    ["error", "danger"],
    ["success", "success"],
]);
export function getRedirectOnImportPath(response, isRunFormRedirect = false) {
    var _a, _b, _c;
    if (isRunFormRedirect) {
        return { path: "/workflows/run", query: { id: response.id } };
    }
    else {
        return {
            path: "/workflows/list",
            query: {
                message: (_a = response.message) !== null && _a !== void 0 ? _a : "Import Successful",
                status: (_c = statusMap.get((_b = response.status) !== null && _b !== void 0 ? _b : "")) !== null && _c !== void 0 ? _c : "success",
            },
        };
    }
}
